import React from "react";
import useScreenResolution from "../../../hooks/useScreenResolution";

const shimmer =
  "relative overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[policyShimmer_1.4s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/50 before:to-transparent";

const Bar = ({ className = "" }) => (
  <span className={`block rounded-md ${shimmer} ${className}`} />
);

const LifePolicyOverviewSkeleton = () => {
  const { mobile } = useScreenResolution();

  return (
    <div className="p-6 max767:p-0 max767:m-0" aria-hidden="true">
      <style>{`@keyframes policyShimmer { 100% { transform: translateX(100%); } }`}</style>

      {!mobile && <Bar className="h-4 w-56 mb-5 bg-[#DDE2E4]" />}

      {mobile && (
        <div className="flex items-center justify-between bg-[#E8F3E8] p-4 sticky top-0 z-10 gap-3">
          <Bar className="h-8 w-8 shrink-0 rounded-full bg-[#BDD0BD]" />
          <Bar className="h-5 flex-1 bg-[#BDD0BD]" />
          <Bar className="h-8 w-8 shrink-0 rounded-full bg-[#BDD0BD]" />
        </div>
      )}

      <div className="bg-[#E8F3E8] rounded-2xl px-5 py-6 mt-6 mb-4 max767:mt-0 max767:rounded-none flex justify-between items-start max767:flex-col">
        <div className="flex flex-col gap-3 w-full">
          {!mobile && (
            <Bar className="h-4 w-16 bg-[#BDD0BD] mb-1" />
          )}
          <Bar className="h-6 w-24 rounded-lg bg-[#BDD0BD]" />
          <Bar className="h-5 w-52 bg-[#BDD0BD] mt-2" />
          <Bar className="h-4 w-40 bg-[#BDD0BD]" />
          {!mobile && (
            <>
              <Bar className="h-9 w-36 bg-[#BDD0BD] mt-2" />
              <Bar className="h-3 w-52 bg-[#BDD0BD]" />
            </>
          )}
          {mobile && (
            <div className="flex flex-col gap-2 mt-8">
              <Bar className="h-4 w-28 bg-[#BDD0BD]" />
              <Bar className="h-9 w-44 bg-[#BDD0BD]" />
              <Bar className="h-3 w-36 bg-[#BDD0BD]" />
            </div>
          )}
        </div>
      </div>

      <div className="flex gap-1 border-b border-[#DDE2E4] mb-2 max767:px-0 max767:overflow-x-hidden">
        {[130, 112, 130, 115, 108].map((w, i) => (
          <Bar
            key={i}
            className="h-10 rounded-t-md rounded-b-none bg-[#E5E9EB]"
            style={{ width: w, minWidth: w }}
          />
        ))}
      </div>

      <div className="max767:p-5 mt-4">
        <div className="flex flex-wrap gap-4 ipad:gap-2 max767:grid max767:grid-cols-2">
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              className="bg-[#F0E9D8] rounded-2xl p-6 flex flex-col justify-between h-[163px] flex-1 max767:h-[150px] ipad:p-3 ipad:h-[140px]"
            >
              <Bar className="h-9 w-9 rounded-lg bg-[#E0D4BF]" />
              <div className="flex flex-col gap-2 w-full">
                <Bar className="h-3 w-20 bg-[#E0D4BF]" />
                <Bar className="h-5 w-32 bg-[#E0D4BF]" />
              </div>
            </div>
          ))}
        </div>

        <div className="flex gap-4 mt-4 max767:flex-col ipad:flex-col">
          <div className="w-[59.5%] max767:w-full ipad:w-full">
            {[0, 1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="flex justify-between py-3 border-b border-[#DDE2E4]"
              >
                <Bar className="h-4 w-28 bg-[#E5E9EB]" />
                <Bar className="h-4 w-24 bg-[#E5E9EB]" />
              </div>
            ))}
          </div>

          {!mobile && (
            <div className="flex flex-col w-2/5 items-end gap-3">
              <div className="bg-[#F0E9D8] rounded-2xl p-6 w-full flex flex-col gap-3">
                <Bar className="h-3 w-24 bg-[#E0D4BF]" />
                <Bar className="h-6 w-28 bg-[#E0D4BF]" />
                <Bar className="h-9 w-36 rounded-md bg-[#E0D4BF]" />
              </div>
              <div className="bg-[#F0E9D8] rounded-2xl p-6 w-full flex flex-col gap-2 mt-1">
                <Bar className="h-4 w-44 bg-[#E0D4BF]" />
                <Bar className="h-9 w-full bg-[#E0D4BF]" />
                <Bar className="h-9 w-full bg-[#E0D4BF]" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LifePolicyOverviewSkeleton;
